<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OYJsSP/images/9781429984096.jpg?1727382324105" alt="This image is the cover for the book Strange Death of Father Candy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strange Death of Father Candy
      </h1>
      <p class="bookDescription body article font2">
        <p>Vietnam veteran Dominick Candiotti has been long estranged from his family. His late parents were close to the ruling mob clan in Youngstown, his sister was a bad-tempered and dissatisfied nag, and his middle brother was a corruptible police lieutenant. But in 1985, their oldest brother Richard Candiotti---beloved by every Italian Catholic in Youngstown as "Father Candy"---dies, and Dominick returns home for the funeral.<br/><br/>Dominick is greatly disturbed by Richard's death, which has been ruled a suicide. Dissatisfied with this answer, he sets out to find the truth, revealing secrets and coming face-to-face with brutality and violence. <br/><br/>Award-winning author Les Roberts pens a riveting and moving tale about walking the fragile tightrope between love and hatred.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Les Roberts
      </h2>
      
      <p class="authorDescription body article"><P><B>Les Roberts</B> won the initial PWA Best First Private Eye Novel Competition and is the author of the Milan Jacovich mystery series. He is a winner of the Cleveland Arts Prize for Literature and the Sherwood Anderson Literary Award. Roberts lives in Ohio.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f0d10cbc